import { Settings } from "@mui/icons-material";
import { IFeatures } from "../../utils/interfaces";

import { useSessionContext } from "../../contexts/SessionContext";
import { ManagerProtocol } from "./ManagerProtocol";
import { TemplateManagerPage } from "./TemplateManagerPage";
import { currentFeatures } from "@/configs/Settings";

/**
 * Configura a página de gerenciar protocolos (lista, editar, etc.).
 * Ativa quando NÃO for defaultApp: gestão fora do atendimento.
 * Quando !defaultApp usa FluxVet (TemplateManager); senão ManagerProtocol.
 */
export function useManageProtocol() {
  const { access } = useSessionContext();
  const configs: IFeatures = {
    active: access?.type === "professional",
    path: "/manageprotocol",
    icon: Settings,
    text: "Gerenciar protocolos",

    subitem: true,
    parent: "Protocolos clínicos",

    sideMenu: true,
    sideMenuIndex: 0,

    component: () =>
      !currentFeatures.defaultApp ? (
        <TemplateManagerPage />
      ) : (
        <ManagerProtocol />
      ),
  };

  return configs;
}
